/*! bxs-vue-ui v4.0.1 */
import { i as indexOf } from '../utils/es.array.join.js';
import { c as create, n as normalizeComponent } from '../utils/normalize-component.js';
import { t as themeSwitcher, f as forEach } from '../utils/index.js';
import '../utils/string-trim.js';
import { _ as _parseInt } from '../utils/parse-int.js';
import Vue from 'vue';
import { p as promise } from '../utils/promise.js';
import { _ as _extends } from '../utils/extends.js';
import { k as keys } from '../utils/keys.js';
import '../utils/concat.js';

var ENUM_TYPES = themeSwitcher.getThemeProps()['default-page'] || {};
var ENUM_TYPES_KEYS = keys(ENUM_TYPES);

var script = create({
  name: 'default-page',
  props: {
    // 是否是局部布局
    inline: {
      type: Boolean,
      default: true
    },
    // 是否是更大的
    large: {
      type: Boolean,
      default: false
    },
    // 局部显示是否自适应
    responsive: {
      type: Boolean,
      default: true
    },
    // 错误类型
    type: {
      type: String,
      default: 'empty',
      validator: function validator(type) {
        return indexOf(ENUM_TYPES_KEYS).call(ENUM_TYPES_KEYS, type) !== -1;
      }
    },
    // 错误图片
    image: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    // 错误文案
    text: {
      type: String,
      default: ''
    },
    // 行动按钮文案
    label: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: true,
      innerStyle: {},
      action: null
    };
  },
  computed: {
    preset: function preset() {
      var myThemeProps = this.$myThemeProps;
      return myThemeProps[this.type] || myThemeProps.empty || {};
    },
    imgData: function imgData() {
      return this.image || this.preset.image;
    },
    txtData: function txtData() {
      return this.text || this.preset.text;
    }
  },
  methods: {
    // 触发行动按钮事件
    handleAction: function handleAction() {
      if (this.action) {
        this.action();
      }

      this.$emit('action');
    },
    // 计算页面还留多少空白高度
    calculateBlank: function calculateBlank() {
      var self = this;
      return new promise(function (resolve, reject) {
        // 图片loaded后再计算高度
        var $img = self && self.$refs && self.$refs.defaultpageImage;

        if (!$img) {
          reject();
          return;
        }

        $img.onload = function () {
          var blankHeight = 0; // 查看body是否存在留白

          blankHeight = window.innerHeight - document.body.clientHeight;

          if (blankHeight > 0) {
            resolve(blankHeight);
          } // 若body发现没有留白，再查找body下的第一个元素，查看是否存在留白


          var firstElement = document.body.firstElementChild; // 第一个元素不是div，则不再处理

          if (firstElement.nodeName !== 'DIV') {
            resolve(0);
          }

          blankHeight = window.innerHeight - firstElement.clientHeight;

          if (blankHeight > 0) {
            resolve(blankHeight);
          } // 未有留白统一返回0


          resolve(0);
        };

        $img.onerror = function () {
          resolve(0);
        };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.inline && this.responsive) {
      this.$nextTick(function () {
        // 动态取paddingBottom的值
        var paddingBottom = window.getComputedStyle(_this.$el.childNodes[0]).paddingBottom.replace('px', '');
        paddingBottom = _parseInt(paddingBottom, 10);

        _this.calculateBlank().then(function (height) {
          paddingBottom += height;

          _this.$set(_this.innerStyle, 'paddingBottom', paddingBottom + "px");
        });
      });
    }
  }
});

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.visible ? _c('div', {
    class: {
      'bx-defaultpage-inline': _vm.inline,
      'bx-defaultpage-fixed': !_vm.inline,
      'bx-defaultpage-large': _vm.large
    }
  }, [_c('div', {
    staticClass: "bx-defaultpage-inner",
    style: _vm.innerStyle
  }, [_c('div', {
    staticClass: "bx-defaultpage-image",
    class: _vm.imageClass
  }, [_c('img', {
    ref: "defaultpageImage",
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.imgData
    }
  })]), _c('div', {
    staticClass: "bx-defaultpage-text",
    domProps: {
      "innerHTML": _vm._s(_vm.txtData)
    }
  }), _vm.label ? _c('div', {
    staticClass: "bx-defaultpage-group"
  }, [_c('a', {
    staticClass: "bx-defaultpage-btn",
    on: {
      "click": _vm.handleAction
    }
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()])]) : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var defaultOptions = {
  inline: false,
  large: true
};
var DefaultPageConstructor = Vue.extend(__vue_component__);
var instance = null;

var getInstance = function getInstance() {
  return new DefaultPageConstructor({
    el: document.createElement('div')
  });
};

var DefaultPage = function DefaultPage(options) {
  if (options === void 0) {
    options = {};
  }

  instance = getInstance();

  _extends(instance, defaultOptions, options);

  document.body.appendChild(instance.$el);
};
/* eslint-disable no-param-reassign */


forEach(ENUM_TYPES_KEYS).call(ENUM_TYPES_KEYS, function (key) {
  DefaultPage[key] = function (options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof options === 'string') {
      options = {
        text: options
      };
    }

    var defaults = {
      type: key
    };
    options = _extends({}, defaults, options); // eslint-disable-next-line

    new DefaultPage(options);
  };
});
/* eslint-enable no-param-reassign */


DefaultPage.view = __vue_component__;

DefaultPage.remove = function () {
  if (instance) {
    instance.visible = false;
  }
};

DefaultPage.hide = function () {
  if (instance) {
    instance.visible = false;
  }
};

DefaultPage.install = function (vueGlobal) {
  vueGlobal.use(__vue_component__);
  /* eslint no-param-reassign: ["Error", { "props": false }] */

  vueGlobal.prototype.$defaultPage = DefaultPage;
};

export default DefaultPage;
